var map = {
	"./Approved.svg": 3814,
	"./AwaitingParts.svg": 3815,
	"./Closed.svg": 3816,
	"./Completed.svg": 3817,
	"./Excel.svg": 3818,
	"./Exportall_grey.svg": 3819,
	"./Exportall_grey_circle.svg": 3820,
	"./InProgress.svg": 3821,
	"./New.svg": 3822,
	"./View_Pic_Grey.svg": 3823,
	"./accident.svg": 3824,
	"./account.svg": 3825,
	"./addOrange.svg": 3826,
	"./addUser.svg": 3827,
	"./addVehicle.svg": 3828,
	"./address.svg": 3829,
	"./alert.svg": 3830,
	"./all_active.svg": 3831,
	"./all_active_es.svg": 3832,
	"./arrow-down.svg": 3833,
	"./arrow-up.svg": 3834,
	"./arrowRight.svg": 3835,
	"./awaiting_parts_grey.svg": 3836,
	"./awaiting_parts_orange.svg": 3837,
	"./back-btn.svg": 3838,
	"./back-button-grey.svg": 3839,
	"./backButton.svg": 3840,
	"./bills_of_landing_active.svg": 3841,
	"./bills_of_landing_active_es.svg": 3842,
	"./bobTail.svg": 3843,
	"./book-solid.svg": 3844,
	"./boxTruck.svg": 3845,
	"./calanderIcon.svg": 3846,
	"./cameraSelected.svg": 3847,
	"./camera_selected.svg": 3848,
	"./chat-icon.svg": 3849,
	"./circle-Exportall_grey.svg": 3850,
	"./circle-export.svg": 3851,
	"./circle-exportUser.svg": 3852,
	"./circle-import.svg": 3853,
	"./circle-importUser.svg": 3854,
	"./circle-viewall.svg": 3855,
	"./clearAll.svg": 3856,
	"./close-popup.svg": 3857,
	"./closeMap.svg": 3858,
	"./closed-Orange.svg": 3859,
	"./closed-grey.svg": 3860,
	"./clusterIcon.svg": 3861,
	"./communication_records_active.svg": 3862,
	"./communication_records_active_es.svg": 3863,
	"./company.svg": 3864,
	"./companyIcon.svg": 3865,
	"./complete-Orange.svg": 3866,
	"./complete-grey.svg": 3867,
	"./csa.svg": 3868,
	"./csaSnapshot.svg": 3869,
	"./dailyDocuments.svg": 3870,
	"./dashboard.svg": 3871,
	"./dashboardIcon.svg": 3872,
	"./date.svg": 3873,
	"./delete.svg": 3874,
	"./deleteCircle.svg": 3875,
	"./delivery_receipts_active.svg": 3876,
	"./delivery_receipts_active_es.svg": 3877,
	"./departments.svg": 3878,
	"./departmetEdit.svg": 3879,
	"./developer.svg": 3880,
	"./direction.svg": 3881,
	"./dispatch_records_active.svg": 3882,
	"./dispatch_records_active_es.svg": 3883,
	"./document.svg": 3884,
	"./documents.svg": 3885,
	"./dot.svg": 3886,
	"./dotAudit.svg": 3887,
	"./dotauditIcon.svg": 3888,
	"./downarrowIcon.svg": 3889,
	"./download.svg": 3890,
	"./downloadCenter.svg": 3891,
	"./downloadCenterMenu.svg": 3892,
	"./driver-behaviour.svg": 3893,
	"./driver.svg": 3894,
	"./dryVan.svg": 3895,
	"./dtc.svg": 3896,
	"./dualCam.svg": 3897,
	"./dump.svg": 3898,
	"./edit.svg": 3899,
	"./editLogIcon.svg": 3900,
	"./editSvg.svg": 3901,
	"./en.svg": 3902,
	"./es.svg": 3903,
	"./excelNew.svg": 3904,
	"./export-grey.svg": 3905,
	"./export.svg": 3906,
	"./exportUser.svg": 3907,
	"./feedback.svg": 3908,
	"./file-pdf-regular.svg": 3909,
	"./filter.svg": 3910,
	"./flatBed.svg": 3911,
	"./fleet.svg": 3912,
	"./fleetCompanies.svg": 3913,
	"./fleetdriverIcon.svg": 3914,
	"./fleetvehiclesIcon.svg": 3915,
	"./fletBed.svg": 3916,
	"./fr.svg": 3917,
	"./fuel.svg": 3918,
	"./full.svg": 3919,
	"./hamburger.svg": 3920,
	"./help-icon.svg": 3921,
	"./historyLogs.svg": 3922,
	"./icon-delete.svg": 3923,
	"./icon-export.svg": 3924,
	"./icon-menu-logs.svg": 3925,
	"./ifta.svg": 3926,
	"./import.svg": 3927,
	"./importUser.svg": 3928,
	"./in_progress_grey.svg": 3929,
	"./in_progress_orange.svg": 3930,
	"./infoTruck.svg": 3931,
	"./inspection-dvir.svg": 3932,
	"./inspection.svg": 3933,
	"./key.svg": 3934,
	"./leftArrow.svg": 3935,
	"./location.svg": 3936,
	"./locationMap.svg": 3937,
	"./log.svg": 3938,
	"./logEdit.svg": 3939,
	"./logHistory.svg": 3940,
	"./logoutIcon.svg": 3941,
	"./logs.svg": 3942,
	"./logsIcon.svg": 3943,
	"./mack.svg": 3944,
	"./mail.svg": 3945,
	"./main_camera.svg": 3946,
	"./mappinPopup.svg": 3947,
	"./menu_companies.svg": 3948,
	"./menu_dailyLog.svg": 3949,
	"./menu_reports.svg": 3950,
	"./menu_reseller.svg": 3951,
	"./menu_vehicle.svg": 3952,
	"./messageSender.svg": 3953,
	"./messaging.svg": 3954,
	"./new_login.svg": 3955,
	"./ninePin.svg": 3956,
	"./nonEdit.svg": 3957,
	"./notFull.svg": 3958,
	"./not_started_grey.svg": 3959,
	"./not_started_orange.svg": 3960,
	"./otherTrailer.svg": 3961,
	"./otherTruck.svg": 3962,
	"./other_documents_active.svg": 3963,
	"./other_documents_active_es.svg": 3964,
	"./overview.svg": 3965,
	"./page-first.svg": 3966,
	"./page-last.svg": 3967,
	"./page-next.svg": 3968,
	"./page-prev.svg": 3969,
	"./phone.svg": 3970,
	"./pickup.svg": 3971,
	"./pneumaticTrailer.svg": 3972,
	"./policy.svg": 3973,
	"./popupClose.svg": 3974,
	"./popupConfirm.svg": 3975,
	"./popupDelete.svg": 3976,
	"./privatePassenger.svg": 3977,
	"./qbdii.svg": 3978,
	"./receipts_active.svg": 3979,
	"./receipts_active_es.svg": 3980,
	"./reeferTrailer.svg": 3981,
	"./refreshCircle.svg": 3982,
	"./renewal.svg": 3983,
	"./repair.svg": 3984,
	"./reportIcon.svg": 3985,
	"./reports.svg": 3986,
	"./save-regular.svg": 3987,
	"./scoreCard.svg": 3988,
	"./searchGrey.svg": 3989,
	"./selectedConnection.svg": 3990,
	"./share.svg": 3991,
	"./sixPin.svg": 3992,
	"./sort.svg": 3993,
	"./speedometer.svg": 3994,
	"./spotlightGreen.svg": 3995,
	"./spotlightGrey.svg": 3996,
	"./spotlightRed.svg": 3997,
	"./straightTruck.svg": 3998,
	"./supportIcon.svg": 3999,
	"./switch.svg": 4000,
	"./tankerTrailer.svg": 4001,
	"./tick.svg": 4002,
	"./time.svg": 4003,
	"./timePicker.svg": 4004,
	"./toggle-off.svg": 4005,
	"./toggle-on.svg": 4006,
	"./tools.svg": 4007,
	"./tractorDayCab.svg": 4008,
	"./tractorSleeper.svg": 4009,
	"./undelete.svg": 4010,
	"./unsaved.svg": 4011,
	"./update.svg": 4012,
	"./upload.svg": 4013,
	"./usdot.svg": 4014,
	"./user.svg": 4015,
	"./userprofileIcon.svg": 4016,
	"./users.svg": 4017,
	"./vacuumTrailer.svg": 4018,
	"./vacuumTruck.svg": 4019,
	"./van.svg": 4020,
	"./vehicle-behaviour.svg": 4021,
	"./vehicle.svg": 4022,
	"./vehicleIcon.svg": 4023,
	"./viewArrow.svg": 4024,
	"./viewDocument.svg": 4025,
	"./viewReports.svg": 4026,
	"./viewStatus.svg": 4027,
	"./viewallMap.svg": 4028,
	"./violation.svg": 4029,
	"./volvo.svg": 4030,
	"./weigh_tickets_active.svg": 4031,
	"./weigh_tickets_active_es.svg": 4032,
	"./whitecheck_new.svg": 4033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3813;